import { triggerNodesDocs } from "./triggerNodesDocs";
import { actionNodesDocs } from "./actionNodesDocs";
import { conditionalNodesDocs } from "./conditionalNodesDocs";
import { exportNodesDocs } from "./exportNodesDocs";
import { aiNodesDocs } from "./aiNodesDocs";
import { additionalNodesDocs } from "./additionalNodesDocs";

export interface NodeDocContent {
  title: string;
  subtitle: string;
  color: string;
  badge: string;
  description: string;
  content: string;
}

export interface NodeCategory {
  name: string;
  icon: string;
  color: string;
  description: string;
  nodes: string[];
}

export const nodeCategories: NodeCategory[] = [
  {
    name: "Trigger Nodes",
    icon: "zap",
    color: "amber",
    description: "Start your workflow automatically",
    nodes: [
      "FILE-UPLOAD",
      "DOCUMENT-STORE",
      "HTTP",
      "ONEDRIVE-CONNECTOR",
      "GMAIL_CONNECTOR",
      "OUTLOOK-CONNECTOR",
      "SCHEDULE",
    ],
  },
  {
    name: "AI Nodes",
    icon: "brain-circuit",
    color: "violet",
    description: "Leverage AI for intelligence-driven processing",
    nodes: [
      "FILE-OCR",
      "SUMMARY",
      "CLOUD-VISION",
      "GEMINI-UNDERSTANDING",
      "FILE-COMPARE",
      "EMAIL-OCR",
      "SMART-PARSE",
    ],
  },
  {
    name: "Action Nodes",
    icon: "layers",
    color: "indigo",
    description: "Transform and process your data",
    nodes: [
      "TRANSFORM",
      "CODE",
      "HTTP-API",
      "PDF",
      "WEB-SCRAPER",
      "ERROR-CATCHER",
    ],
  },
  {
    name: "Conditional Nodes",
    icon: "git-branch",
    color: "violet",
    description: "Control the flow of your workflow",
    nodes: [
      "IF-ELSE",
      "SWITCH",
      "FOR-EACH",
      "VALIDATOR",
    ],
  },
  {
    name: "Export Nodes",
    icon: "external-link",
    color: "emerald",
    description: "Save and export your processed data",
    nodes: [
      "FILE-DATABASE",
      "WEBHOOK",
      "EXCEL",
      "WORD",
      "ONEDRIVE-UPLOAD",
      "OUTLOOK-SEND",
      "GMAIL-SEND",
      "DOCXIQ-EXPORT",
      "POSTGRES",
    ],
  },
];


export const nodeDocsData: Record<string, NodeDocContent> = {
  ...triggerNodesDocs,
  ...actionNodesDocs,
  ...conditionalNodesDocs,
  ...exportNodesDocs,
  ...aiNodesDocs,
  ...additionalNodesDocs,
};
